var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccepted = function SvgAccepted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 12.667a4.667 4.667 0 1 1 0-9.334 4.667 4.667 0 0 1 0 9.334ZM2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm8.893-.855a.667.667 0 0 0-.93-.956L7.008 9.064 5.805 7.862a.667.667 0 1 0-.943.943l1.667 1.666c.257.258.674.261.936.007l3.428-3.333Z",
    clipRule: "evenodd"
  })));
};
export default SvgAccepted;